<template>
  <section>
    <div class="defaultDiv">
      <noPower></noPower>
    </div>
    <mbComSelect></mbComSelect>
  </section>
</template>
<script>
import noPower from "@/components/tips/noPower";
import mbComSelect from "@/components/mbComSelect/index.vue";
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {
    noPower,
    mbComSelect
  },
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.defaultDiv {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
